import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=a98e0d76&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=a98e0d76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98e0d76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a98e0d76')) {
      api.createRecord('a98e0d76', component.options)
    } else {
      api.reload('a98e0d76', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=a98e0d76&scoped=true&", function () {
      api.rerender('a98e0d76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2t3OSiYSlJQ7X/JS/comp/PopupDialog.vue"
export default component.exports